import { createFileRoute } from "@tanstack/react-router";
import { OnboardingVorab } from "@/pages/client/OnboardingVorab";

/**
 * Die Onboarding-Fragen aus Kundensicht — vorab beantworten (02.09.2026).
 * Für Team-Konten nur in der Kunden-Vorschau sinnvoll; die Seite selbst
 * zeigt dann den Stand des Kunden lesend.
 */
export const Route = createFileRoute("/_angemeldet/vorbereitung")({
	component: OnboardingVorab,
});
